import { Divider, Chip, Typography, Box } from "@mui/material";

const Explain = () => {
  return (
    <>
      <div id="about" style={{ paddingTop: "60px" }}>
        <Divider
          textAlign="center"
          sx={{
            mt: 5,
            "&::before,&::after": {
              borderColor: "primary",
            },
          }}
        >
          <Chip
            sx={{ p: 3 }}
            label={
              <Typography variant="h2" sx={{ fontSize: "2rem", margin: 2 }}>
                درباره ی ایما
              </Typography>
            }
          ></Chip>
        </Divider>
        <Box>
          <Typography
            variant="body1"
            sx={{ p: 2.5, fontSize: "1.2rem", textAlign: "center" }}
          >
            گروه صنعتی ایما به عنوان واحد خدمات مهندسی و تهیه تجهیزات برای
            کارخانجات صنعتی ، صنایع نفت و گاز با هدف ارائه مشاوره فنی ،اجرای
            پروژه های صنعتی ، مهندسی فروش، اقلام مورد نیاز صنایع در زمینه
            اتوماسیون صنعتی ، سیستم های مانیتورینگ صنعتی ، گزارش گیری ، کنترل و
            تجهیزات اندازه گیری و ابزاردقیق در سال 1384 تاسیس گردید.
          </Typography>
          <Typography
            variant="body1"
            sx={{ p: 0, fontSize: "1.2rem", textAlign: "center" }}
          >
            واحد فروش گروه صنعتی ایما جهت فروش اینترنتی محصولات قابل ارائه خود
            سایتی به نام دیجیماکالا به نشانی{" "}
            <span style={{ fontFamily: "roboto", fontSize: "1.1rem" }}>
              www.digimakala.com
            </span>{" "}
            راه اندازی نموده است.
          </Typography>
          <Typography variant="body1" sx={{ fontSize: "1.2rem", pl: 3, p: 3 }}>
            گروه صنعتی ایما از 3 واحد عمده تشکیل یافته است:
          </Typography>
        </Box>
      </div>
    </>
  );
};
export default Explain;
